export default "__VITE_ASSET__XoyjgTbt__"